import React from 'react';
import Search from './Search';
import Logo from './Logo';


function Constants() {
  return (
    <div>
     <Logo/>
   <Search/>
     
    
    </div>
  )
}



export default Constants;